import { render, staticRenderFns } from "./certification_pop.vue?vue&type=template&id=f6d9c9da&scoped=true"
import script from "./certification_pop.vue?vue&type=script&lang=js"
export * from "./certification_pop.vue?vue&type=script&lang=js"
import style0 from "./certification_pop.vue?vue&type=style&index=0&id=f6d9c9da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d9c9da",
  null
  
)

export default component.exports